import type { TranslationKey } from '@change-corgi/core/i18n';

import type { PetitionEditPageState } from '#src/app/pages/petitionEditV2/pageContext';

type Field = keyof PetitionEditPageState['formState'];

type SchemaResult = Readonly<Record<Field, unknown>>;
// transform form state to zod schema structure for parsing/validation
export function transformFormStateToSchema(state: PetitionEditPageState): SchemaResult {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const keys = Object.keys(state.formState) as readonly Field[];

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return keys.reduce((result, key) => ({ ...result, [key]: state.formState[key].value }), {}) as SchemaResult;
}

type ErrorsResult = Readonly<Record<Field, TranslationKey>>;
// transform zod errors to form state errors
export function transformZodErrorToFormState(zodErrors: Partial<Record<Field, string[]>>): Partial<ErrorsResult> {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const keys = Object.keys(zodErrors) as readonly Field[];

	return keys.reduce((result, key) => {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const errorString = (zodErrors[key]?.toString() as unknown as TranslationKey | undefined) || null;

		if (errorString === null) return result;

		return { ...result, [key]: errorString };
	}, {});
}
